import { render, staticRenderFns } from "./milling_approve.vue?vue&type=template&id=5d6221e3"
import script from "./milling_approve.vue?vue&type=script&lang=js"
export * from "./milling_approve.vue?vue&type=script&lang=js"
import style0 from "./milling_approve.vue?vue&type=style&index=0&id=5d6221e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports